import { render, staticRenderFns } from "./AdmisionInscripcion.vue?vue&type=template&id=2296d47e"
import script from "./AdmisionInscripcion.vue?vue&type=script&lang=js"
export * from "./AdmisionInscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports